import { render, staticRenderFns } from "./FlightsDashboardTable.vue?vue&type=template&id=f622f6ce&"
import script from "./FlightsDashboardTable.vue?vue&type=script&lang=js&"
export * from "./FlightsDashboardTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports